<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add">
      新增
    </a-button>
    <a-modal centered v-model="visible" title="新增任务" @ok="handleOk">
      <p>任务类型</p>
      <a-select
        style="width: 120px"
        defaultValue="1"
        v-model="formInline.taskType"
        placeholder="请选择"
      >
        <!-- <a-select-option :value="1">签到</a-select-option> -->
        <a-select-option :value="2">积分兑换</a-select-option>
      </a-select>
      <p>任务标题</p>
      <a-input v-model="formInline.taskTitle" placeholder="请输入任务标题，标题请勿过长" />
      <div v-if="formInline.taskType === 1">
        <p>签到天数</p>
        <a-input v-model="formInline.signDay" placeholder="签到天数" />
      </div>
      <div v-if="formInline.taskType === 1">
      <p>所得积分</p>
      <a-input v-model="formInline.integral" placeholder="请设置任务积分数量" />
      </div>
      <p>任务有效期至</p>
      <a-range-picker format="YYYY-MM-DD HH:mm:ss" @change="onChange" />
      <div v-if="formInline.taskType === 1">
        <p>赠送币数</p>
        <a-input v-model="formInline.quantity" placeholder="请输入赠送币数" />
      </div>
      <div v-if="formInline.taskType === 2">
        <p>1币与积分比例</p>
        <a-input v-model="formInline.quantity" placeholder="请输入比例数值" />
      </div>
      <p>任务表述</p>
      <a-textarea
        placeholder="textarea with clear icon"
        allow-clear
        v-model="formInline.taskDesc"
        @change="onChange"
      />
    </a-modal>
    <a-modal centered v-model="visibleEdit" title="修改任务" @ok="handleOkEdit">
      <p>任务类型</p>
      <a-select
        style="width: 120px"
        defaultValue="1"
        v-model="formInlineEdit.taskTypeEdit"
      >
        <!-- <a-select-option :value="1">签到</a-select-option> -->
         <a-select-option :value="2">积分兑换</a-select-option>
      </a-select>
      <p>任务标题</p>
      <a-input
        v-model="formInlineEdit.taskTitleEdit"
        placeholder="请输入任务标题，标题请勿过长"
      />
      <div v-if="formInlineEdit.taskTypeEdit === 1">
        <p>签到天数</p>
        <a-input v-model="formInlineEdit.signDayEdit"  placeholder="签到天数" />
      </div>
      
      <div v-if="formInlineEdit.taskTypeEdit === 1">
        <p>所得积分</p>
        <a-input v-model="formInlineEdit.integralEdit" placeholder="请设置任务积分数量" />
      </div>
      <p>任务有效期至</p>
      <a-range-picker v-model="dateTime" format="YYYY-MM-DD HH:mm:ss" @change="onChange" />
      <div v-if="formInlineEdit.taskTypeEdit === 1">
        <p>赠送币数</p>
        <a-input v-model="formInlineEdit.quantityEdit" placeholder="请输入赠送币数" />
      </div>
      <div v-if="formInlineEdit.taskTypeEdit === 2">
        <p>1币与积分换算比例</p>
        <a-input v-model="formInlineEdit.quantityEdit" placeholder="请输入比例数值" />
      </div>
      <p>任务表述</p>
      <a-textarea
        placeholder="请输入任务表述"
        allow-clear
        v-model="formInlineEdit.taskDescEdit"
        @change="onChange"
      />
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template>
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">修改</a>
        <a @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  addTaskList,
  TaskList,
  updateTaskList,
  delTaskList,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "任务标题",
    align: "center",
    dataIndex: "taskTitle",
  },
  {
    title: "任务类型",
    align: "center",
    dataIndex: "taskType",
  },
  // {
  //   title: "所得积分",
  //   align: "center",
  //   dataIndex: "integral",
  // },
  {
    title: "兑换比例",
    align: "center",
    dataIndex: "quantity",
  },
  {
    title: "任务有效期至",
    align: "center",
    dataIndex: "endTime",
    sorter: true,
  },
  {
    title: "创建时间",
    align: "center",
    dataIndex: "startTime",
    sorter: true,
    scopedSlots: { customRender: "startTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      visibleEdit: false,
      formInline: {
        integral: "",
        taskTitle: "",
        taskType: "",
        startTime: "",
        endTime: "",
        taskDesc: "",
        quantity: "",
        signDay: "",
      },
      formInlineEdit: {
        objIdEdit: "",
        integralEdit: "",
        taskTitleEdit: "",
        taskTypeEdit: "",
        startTimeEdit: "",
        endTimeEdit: "",
        taskDescEdit: "",
        quantityEdit: "",
        signDayEdit: "",
      },
      dateTime: "",
    };
  },
  mounted() {
    this.getTaskListData();
  },
  props: ["task"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      TaskList({ limit: 10, page: this.pagination.current }).then((res) => {
        this.data = res.data;
        console.log(res);
      });
      this.loading = false;
    },
    add() {
      this.visible = true;
    },
    edit(row) {
      console.log(row);
      this.visibleEdit = true;
      this.formInlineEdit.objIdEdit = row.objId;
      this.formInlineEdit.taskTitleEdit = row.taskTitle;
      this.formInlineEdit.taskTypeEdit = row.taskType;
      this.formInlineEdit.integralEdit = row.integral;
      this.formInlineEdit.quantityEdit = row.quantity;
      this.formInlineEdit.taskDescEdit = row.taskDesc;
      this.formInlineEdit.startTimeEdit = row.startTime;
      this.formInlineEdit.endTimeEdit = row.endTime;
      this.dateTime = [row.startTime, row.endTime];
      this.formInlineEdit.signDayEdit = row.signDay;
    },
    del(row) {
      console.log(row);
      this.loading = true;
      delTaskList(row.objId).then((res) => {
        this.loading = false;
        message.success(res.data);
        this.getTaskListData();
      });
    },
    //
    onChange(date, dateString) {
      this.formInline.startTime = dateString[0];
      this.formInline.endTime = dateString[1];
      this.formInlineEdit.startTimeEdit = dateString[0];
      this.formInlineEdit.endTimeEdit = dateString[1];
    },
    getTaskListData() {
      TaskList({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    query() {
      this.loading = true;
      TaskList(this.task).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
      console.log(this.formInline);
      this.loading = true;
      addTaskList(this.formInline).then((res) => {
        this.getTaskListData();
        this.loading = false;
        message.success(res.data);

        this.formInline = {
        integral: "",
        taskTitle: "",
        taskType: "",
        startTime: "",
        endTime: "",
        taskDesc: "",
        quantity: "",
        signDay: "",
      }
      });
    },
    handleOkEdit() {
      this.visibleEdit = false;
      updateTaskList({
        id: this.formInlineEdit.objIdEdit,
        integral: this.formInlineEdit.integralEdit,
        taskTitle: this.formInlineEdit.taskTitleEdit,
        taskType: this.formInlineEdit.taskTypeEdit,
        startTime: this.formInlineEdit.startTimeEdit,
        endTime: this.formInlineEdit.endTimeEdit,
        taskDesc: this.formInlineEdit.taskDescEdit,
        quantity: this.formInlineEdit.quantityEdit,
        signDay: this.formInlineEdit.signDayEdit,
      }).then((res) => {
        this.getTaskListData();
        console.log(res);
        message.success(res.data);
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/marketingManagement/taskManagement/taskManagementHomeContent.vue